import * as React from "react";
import Container from './Container';
import logo1 from '../images/featured-in/business-wire-logo.png';
import logo2 from '../images/featured-in/fi-news-logo.png';
import logo3 from '../images/featured-in/financial-mirror-logo.png'; 
import logo4 from '../images/featured-in/funds-europe-logo.png';
import logo5 from '../images/featured-in/international-adviser-logo.png';
import logo6 from '../images/featured-in/international-investment-logo.png';
import logo7 from '../images/featured-in/just-landed-modified.webp';
import logo8 from '../images/featured-in/london-post-logo.png';
import logo9 from '../images/featured-in/the-national-uae-logo.png';
import logo10 from '../images/featured-in/wealth-briefing-asia-logo.png';
import logo11 from '../images/featured-in/yahoo-finance-logo.png';

const images = [
    { src: logo1 },
    { src: logo2 },
    { src: logo3 },
    { src: logo4 },
    { src: logo5 },
    { src: logo6 },
    { src: logo7 },
    { src: logo8 },
    { src: logo9 },
    { src: logo10 },
    { src: logo11 },
];

function FeaturedIn() {
    return(
        <Container className="bg-white">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 py-14 mx-auto text-center">
                <div className="col-span-full lg:col-span-12 lg:col-start-1">
                    <h2 className='font-semibold'>Featured In</h2>
                    <div className="flex overflow-hidden pt-8">
                        <div className="animate-marquee">
                            {images.map((image, index) => (
                                <img 
                                    key={index} className="mx-8 md:mx-20" 
                                    src={image.src} 
                                    alt={`Slide ${index}`} 
                                    width="90" 
                                    height="30" 
                                    style={{ objectFit: 'cover' }}
                                />
                            ))}
                            {images.map((image, index) => (
                               <img 
                                    key={index + images.length} 
                                    className="mx-8 md:mx-20" 
                                    src={image.src} 
                                    alt={`Slide ${index}`} 
                                    width="90" 
                                    height="30" 
                                    style={{ objectFit: 'cover' }}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default FeaturedIn;